import { computed, Injectable, signal } from '@angular/core';

/** Tracks the ids of all field-related CDK drop lists (available fields list + column/column-group field drop zones) so any of them can accept a drag from any other. */
@Injectable({
    providedIn: 'root'
})
export class FieldDropListRegistryService {
    private _ids = signal<string[]>([]);

    readonly ids = computed(() => this._ids());

    register(id: string): void {
        if (this._ids().includes(id)) {
            return;
        }

        this._ids.update((ids: string[]) => [...ids, id]);
    }

    unregister(id: string): void {
        this._ids.update((ids: string[]) => ids.filter((existingId: string) => existingId !== id));
    }

    connectedListIds(excludingId: string): string[] {
        return this._ids().filter((id: string) => id !== excludingId);
    }
}
